import {Injectable} from '@angular/core';
import {LineChartSettingsParameters} from '@models/charts/line-chart-settings-parameters';
import {ChartSignalEntry} from '@models/pages/user-defined-page/chart-signal-entry';
import {Chart} from 'highcharts';

@Injectable({
  providedIn: 'root'
})
export class PieChartDataUpdateService {

  public updateChartData(chart: Chart, chartSettings: LineChartSettingsParameters, valuesArray) {
    const series = chart.series;

    if (!this.isDataUpdatePossible(series, valuesArray)) {
      return;
    }

    const value = valuesArray[0];
    const isVariablePie = series[0].type === 'variablepie';
    for (const item of value.vs) {
      const signalId = item.s;
      const signalDefinition: ChartSignalEntry | undefined = this.getSignalDefinition(signalId, chartSettings);
      if (!signalDefinition) {
        continue;
      }
      const point: any = this.getPointBySignal(signalDefinition, series[0]);
      if (!point) {
        continue;
      }
      const numericValue = parseFloat(item.v);
      if (isNaN(numericValue)) {
        continue;
      }
      const sliceValue = Math.abs(numericValue);
      const updatedPointOptions: any = {y: sliceValue, ts: value.ts};
      if (isVariablePie) {
        updatedPointOptions.z = sliceValue;
      }
      point.update(updatedPointOptions, false);
    }
  }

  private isDataUpdatePossible(series, valuesArray): boolean {
    if (!series || series.length === 0) {
      return false;
    }
    if (!valuesArray || valuesArray.length === 0 || !valuesArray[0] || !valuesArray[0].vs || valuesArray[0].vs.length === 0) {
      return false;
    }
    return true;
  }

  private getSignalDefinition(signalId, parameters: LineChartSettingsParameters): ChartSignalEntry | undefined {
    const chartSignals: ChartSignalEntry[] = parameters.chartSettings.signals;
    if (!chartSignals) {
      return undefined;
    }
    return chartSignals.find(chartSignal => chartSignal.signalId == signalId);
  }

  private getPointBySignal(signalDefinition: ChartSignalEntry, series): any {
    return series.data.find((point: any) => point && point.options &&
        (point.options.signalId == signalDefinition.signalId ||
            (signalDefinition.signalName && point.options.signalName === signalDefinition.signalName)));
  }
}
